import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";
// Teams By Services
export const customerSupport = (params) => {
  return Api(endPoints.support, params, requestType.POST);
};
